<template>
<div>

  <!-- View third party modal template -->
  <b-modal id="modal-tabs"
           ref="view-tp"
           hide-footer
           @hide="hideTPModal"
  >

      <div class="d-block text-center">
        <h4 qid="view-tp-title" v-if="object.third_party" class="mb-2">
          <Avatar :object="object.third_party.vendors[0]" size="xs"></Avatar>
          {{ object.third_party.name }}
        </h4>
        <div v-if="object.third_party">
          <span class="text-muted" v-for="(vendor, index) in object.third_party.vendors">
            {{ vendor.name }}
            <span v-if="index < object.third_party.vendors.length - 1">, </span>
          </span>
        </div>

        <div v-if="object.third_party" class="small">
            <span v-if="object.third_party.validation && object.third_party.validation.validation === 1"
                  qid="tp-validation-approved"
            >
              <span >
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              {{ $t('system.approved') }}
            </span>
            <span v-if="object.third_party.validation && object.third_party.validation.validation === 0"
                  qid="tp-validation-rejected"
            >
              <span >
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
              {{ $t('system.rejected') }}
            </span>
            <span v-if="object.third_party.validation && object.third_party.validation.created_by"
                  class="text-muted font-italic"
            >
              {{ $t('system.by') }}
              <span v-if="object.third_party.validation.created_by" qid="view-tp-validation-by">
                {{ object.third_party.validation.created_by.name }}
              </span>
            </span>
            <span v-if="object.third_party.validation && object.third_party.validation.updated_at"
                  class="text-muted font-italic"
            >
              {{ $t('system.on') }}
              <span v-if="object.third_party.validation.created_at" qid="view-tp-validation-date">
                {{ object.third_party.validation.created_at | formatDate }}
              </span>
            </span>
        </div>
      </div>

      <b-tabs class="mt-3">
        <!-- Basic info tab -->
        <b-tab title="Basic info">
          <div v-if="object.third_party">
            <br>

            <div>
              <label>{{ $t('processes.create.tags_label') }}</label>
              <p qid="tp-tags-list">
                <span class="mr-1" v-for="tag in object.third_party.tags_translated" qid="system-tags-list">
                  <span class="badge badge-info mb-1" :title="tag.name_translated">
                    {{ tag.name_translated | truncate(35) }}
                  </span>
                </span>
              </p>
              <br>
            </div>
            <div v-if="object.third_party.description">
              <label>{{ $t('maintenance.third_parties.create.description_label') }}</label>
              <p class="text-formatted">{{ object.third_party.description }}</p>
              <br>
            </div>
            <div v-if="object.third_party.type">
              <label>{{ $t('maintenance.third_parties.create.type_label') }}</label>
              <p>{{ object.third_party.type }}</p>
              <br>
            </div>
            <div v-if="object.third_party.data_processor_agreement">
              <label>{{ $t('maintenance.third_parties.create.data_processor_label') }}</label>
              <p>{{ object.third_party.data_processor_agreement }}</p>
              <br>
            </div>

            <div v-if="object.processing_role">
              <label>{{ $t('systems.view.processing_role_label') }}</label>
              <p>{{ object.processing_role }}</p>
              <br>
            </div>

          </div>

        </b-tab>


        <!-- Data tab -->
        <b-tab title="Data" class="mt-3">
          <div v-if="object.data_objects && object.data_objects.length">
            <label>{{ $t('systems.data_objects.title') }}</label>
            <p>
              <span v-for="dataObject in object.data_objects" :key="dataObject.id">
                <span class="badge badge-info mr-1 mt-1" :title="dataObject.name">
                  {{ dataObject.name | truncate(35) }}
                </span>
              </span>
            </p>
            <p v-if="secondaryDO && secondaryDO.length">
              <span v-for="dataObject in secondaryDO" :key="dataObject.id">
                <span class="badge badge-light mr-1 mt-1" :title="dataObject.name">
                  {{ dataObject.name | truncate(35) }}
                </span>
              </span>
            </p>
            <br>
          </div>
          <div v-if="object.data_objects && !object.data_objects.length">
            <label v-if="object.third_party && object.third_party.data_objects && object.third_party.data_objects.length">Data</label>
            <p v-if="object.third_party && object.third_party.data_objects && object.third_party.data_objects.length">
              <span v-for="dataObject in object.third_party.data_objects" :key="dataObject.id">
                <span class="badge badge-light mr-1 mt-1" :title="dataObject.name">
                  {{ dataObject.name | truncate(35) }}
                </span>
              </span>
            </p>
            <br>
          </div>
          <div v-if="!object.data_objects">
            <div v-if="object.third_party">
              <div v-if="object.third_party.data_objects && object.third_party.data_objects.length">
                <label>{{ $t('systems.data_objects.title') }}</label>
                <p>
                  <span v-for="dataObject in object.third_party.data_objects" :key="dataObject.id">
                    <span class="badge badge-info mr-1 mt-1" :title="dataObject.name">
                      {{ dataObject.name | truncate(35) }}
                    </span>
                  </span>
                </p>
                <br>
              </div>
            </div>
          </div>
        </b-tab>

        <b-button class="float-right"
                  variant="success"
                  @click="hideTPModal"
                  qid="create-p-cancel-button"
        >
          {{ $t('processes.policies.view.close') }}
        </b-button>
        <br>
      </b-tabs>
  </b-modal>


  <!-- Delete attachment modal -->
  <b-modal ref="delete-attachment-modal" hide-footer>
    <div class="d-block text-center">
      <h4 qid="delete-s-title">
        {{ $t('attachments.delete.title') }}
      </h4>
    </div>
    <h5 class="text-center">
      <span>
        {{ $t('attachments.delete.are_you_sure_file') }}
      </span>
    </h5>
    <div class="text-center">
      <b-button class="mt-3"
                variant="secondary"
                @click="hideFileModal"
                qid="delete-attachment-cancel-button"
      >
        {{ $t('attachments.delete.cancel') }}
      </b-button>
      <b-button @click="removeMediaItem(selectedFileObject, selectedFileIndex)"
                class="mt-3 ml-3"
                variant="success"
                qid="delete-attachment-submit-button"
      >
        {{ $t('attachments.delete.submit') }}
      </b-button>
    </div>
  </b-modal>

  <!-- Delete link modal -->
  <b-modal ref="delete-link-modal" hide-footer>
    <div class="d-block text-center">
      <h4 qid="delete-s-title">
        {{ $t('attachments.delete.title') }}
      </h4>
    </div>
    <h5 class="text-center">
      <span>
        {{ $t('attachments.delete.are_you_sure_link') }}
      </span>
    </h5>
    <div class="text-center">
      <b-button class="mt-3"
                variant="secondary"
                @click="hideLinkModal"
                qid="delete-link-cancel-button"
      >
        {{ $t('attachments.delete.cancel') }}
      </b-button>
      <b-button @click="removeLink(selectedLinkObject, selectedLinkIndex)"
                class="mt-3 ml-3"
                variant="success"
                qid="delete-link-submit-button"
      >
        {{ $t('attachments.delete.submit') }}
      </b-button>
    </div>
  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';


  export default {
    name: 'ThirdPartyViewModal',
    data: function() {
      return {
        error: '',
        showInput: false,
        inputLink: '',
        inputLinkName: '',
        loadingItems: false,
        showArticleDescription: false,
        secondaryDO: [],
        selectedFileObject: {},
        selectedFileIndex: '',
        selectedLinkObject: {},
        selectedLinkIndex: '',
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      },
      active: {
        type: Boolean
      },
      attachments: {
        type: Boolean,
        default: true
      }
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getMedia() {
        return this.object.media
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showTPModal()
        }
      }
    },
    methods: {
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      showFileModal(object, index) {
        let self = this
        this.selectedFileObject = object;
        this.selectedFileIndex = index;
        this.$refs['delete-attachment-modal'].show()
      },
      hideFileModal() {
        this.$refs['delete-attachment-modal'].hide()
      },
      showLinkModal(object, index) {
        let self = this
        this.selectedLinkObject = object;
        this.selectedLinkIndex = index;
        this.$refs['delete-link-modal'].show()
      },
      hideLinkModal() {
        this.$refs['delete-link-modal'].hide()
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      handleLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'http://' + this.inputLink
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("model_type", this.object.who_am_i);
        formData.append("model_id", this.object.id);

        piincHttp.post('links', formData).then(function(response) {
          self.$toastr('success', self.$t('processes.legal_basis.link_add_success'))
          self.object.links = response.data.links
          self.inputLink = ''
          self.inputLinkName = ''
          self.showInput = false
        }, function() {})
      },
      removeLink(object, index) {
        let self = this;
        piincHttp.delete('links/'+object.id).then(function() {
          self.object.links.splice(index, 1);
          self.hideLinkModal();
          self.$toastr('success', self.$t('processes.legal_basis.link_delete_success'))
        }, function() {})
      },
      removeMediaItem(object, index) {
        let self = this;
        piincHttp.delete('documents/'+ object.id).then(function() {
          self.object.media.splice(index, 1);
          self.hideFileModal();
          self.$toastr('success', self.$t('processes.legal_basis.media_delete_success'))
        }, function() {})
      },
      onFileChange(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.object.who_am_i);
        formData.append("model_id", this.object.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('processes.legal_basis.media_add_success'))
            self.error = ''
            self.object.media = response.data.media
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      showTPModal() {
        let self = this;
        this.secondaryDO = []
        let inArray = false;

        if (this.object.data_objects && this.object.data_objects.length) {
          if (this.object.third_party.data_objects && this.object.third_party.data_objects.length) {
            _.forEach(this.object.third_party.data_objects, function (dataObject) {
              inArray = false;
              _.forEach(self.object.data_objects, function (item) {
                if (item.id == dataObject.id) {
                  // if item is already in array
                  inArray = true;
                }
              })
              if (!inArray) {
                // If not in array, push it in array as related
                self.secondaryDO.push(dataObject)
              }
            })
          }
        }

        this.$refs['view-tp'].show()
      },
      hideTPModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.showInput = false;
        this.$emit('closeViewModal');
        this.$refs['view-tp'].hide()
      }
    },
    created () {

    }
  }
</script>
